export const prefix = '[File / Details]';
